export default "__VITE_ASSET__12fd13ec__"